import { Route, Routes } from 'react-router-dom';
import UserListPage from './list';

export default function UserRouting() {
  return (
    <Routes>
      <Route index element={<UserListPage />} />
    </Routes>
  );
}
